import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOperatorOutageReportsVm } from '../operator-outage-reports-vm.model';

@Injectable({ providedIn: 'root' })
export class OperatorOutageReportsService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorOutageReports`;
  }

  get(days: number): Observable<IOperatorOutageReportsVm> {
    const headers = this.createHeaders();
    const params = new HttpParams().set('days', days);
    return this.http.get<IOperatorOutageReportsVm>(this.baseUrl, { headers, params });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
